var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTurnoverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 78,
    fill: "none",
    viewBox: "0 0 71 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#121323",
    strokeLinecap: "round",
    d: "M12.472 22.4l12.226 37.456a3.209 3.209 0 0 0 4.155 2.022l39.495-14.46a2.621 2.621 0 0 0 1.56-3.351 2.597 2.597 0 0 0-3.336-1.558L30.045 55.882a1.283 1.283 0 0 1-1.663-.812L11.788 3.796a3.423 3.423 0 0 0-5.03-1.88L2.972 4.202a3.07 3.07 0 0 0-1.298 3.67 2.18 2.18 0 0 0 3.078 1.184L6.28 8.24a1.07 1.07 0 0 1 1.523.616l1.335 4.125"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#121323",
    d: "M10.997 18.697c.585-.214.887-.863.675-1.45a1.123 1.123 0 0 0-1.443-.673 1.133 1.133 0 0 0-.674 1.449c.212.586.858.888 1.442.674z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#121323",
    d: "M34.674 54.19l-8.57-23.684a.863.863 0 0 1 .514-1.104l25.396-9.298a.855.855 0 0 1 1.1.513l8.57 23.684M47.917 21.578L42.462 6.5a.855.855 0 0 0-1.1-.513l-16.335 5.98a.863.863 0 0 0-.514 1.104l5.456 15.078"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#121323",
    strokeWidth: 0.9,
    d: "M30.503 9.956l1.914 5.29a.428.428 0 0 0 .763.086l1.305-2.008a.429.429 0 0 1 .493-.174l2.154.705a.43.43 0 0 0 .537-.557L35.763 8.03"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#121323",
    d: "M35.81 26.026l3.316 9.166a.428.428 0 0 0 .762.09l1.92-2.92a.43.43 0 0 1 .459-.181l3.78.915a.43.43 0 0 0 .505-.566l-3.335-9.216M36.206 76.828c4.287-1.57 6.502-6.327 4.947-10.625a8.234 8.234 0 0 0-10.58-4.941c-4.287 1.57-6.502 6.327-4.947 10.625a8.234 8.234 0 0 0 10.58 4.94z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#121323",
    d: "M34.78 72.886a4.1 4.1 0 0 0 2.44-5.244A4.064 4.064 0 0 0 32 65.204a4.101 4.101 0 0 0-2.442 5.243 4.064 4.064 0 0 0 5.221 2.439z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h70.909v78H0z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnoverIcon);
export default __webpack_public_path__ + "static/media/turnover-icon.56fa078898bae2317f5ac5557fbd9fdc.svg";
export { ForwardRef as ReactComponent };